import React, {PropTypes} from 'react';
import {connect} from 'react-redux';


import {getLocationNameById, getStoreByNumber} from '../../../../utils/stores';
import {titleCase} from '../../../../utils/formatting';


import * as commonActionCreators from '../../../../actions/common';
import * as userActionCreators from '../../../../actions/user';
let allActionCreators = Object.assign({}, commonActionCreators, userActionCreators);

import RhinoLoading from '../../common/RhinoLoading';

class AccountOrders extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {
      rangeOpen: false,
      rangeValue: 'Show All',
      openOrders: [],
    };
	}

	componentDidMount() {

  }

  getOpenOrders() {
    
    let returnArray = [];
    const excludeStatuses = [
      'complete',
      'cancelled'
    ];

    if(!this.props.user.orders) {
      return null;
    }

    for(let i = 0; i < this.props.user.orders.length; i++) {
      if(!excludeStatuses.includes(this.props.user.orders[i].status)) {
        returnArray.push(this.props.user.orders[i]);
      }
    }
    return returnArray;
  }

  getOrders() {

    if(!this.props.user.orders) {
      return null;
    }

    if(this.props.showAll) {
      return this.props.user.orders;
    } else {
      return this.getOpenOrders();
    }
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  getOrderCount(order) {
    if(order.items.length == 1) {
      return order.items.length + ' product';
    } else if(order.items.length > 1) {
      return order.items.length + ' products';
    }
    return '';
  }

  getOrderStatus(order) {
    if(!order || !order.status) {
      return '';
    }
    return titleCase(order.status);
  }

  getItemDescription(item) {
    if(!item || !item.description) {
      return '';
    }
    // return {__html: item.description};
    return item.description;
  }

  getDollars(price) {
    return Math.floor(parseFloat(price)).toLocaleString();
  }

  getCents(price) {
    return parseFloat(price).toFixed(2).slice(-2);
  }

  toggleRangeOpen() {
    this.setState({ rangeOpen: !this.state.rangeOpen });
  }

  updateRange(val) {
    this.setState({ rangeValue: val });
  }

  getShortDate(dateStr) {
    const dispDate = new Date(dateStr);
    const options = { 
      month: 'short',
      day: 'numeric' 
    };
    return dispDate.toLocaleDateString('default', options);
  }

  isOrderOpen(order) {
    return this.state.openOrders.includes(order.id); 
  }

  toggleOrderOpen(order) {

    const shouldAdd = !this.state.openOrders.includes(order.id);
    let newArray = [];

    for(let i = 0; i < this.state.openOrders.length; i++) {
      if(this.state.openOrders[i] != order.id || shouldAdd === true) {
        newArray.push(this.state.openOrders[i]);
      }
    }
    if(shouldAdd === true) {
      newArray.push(order.id);
    }
    this.setState({ openOrders: newArray });
  }

  sendOptMessage() {
    this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
  }

  getItemImageUrl(imageUrl) {
    if(!imageUrl) {
      return null;
    }
    return '/pub/media/catalog/product' + imageUrl;
  }

  externalOrderAccess() {
    
    // Currently not looking at customer access
    return false;

    // if(this.props.showAll) {
    //   // Order history
    //   return this.props.user.userProfile && this.props.user.userProfile.customer.access_orders_history;
    // } else {
    //   // Open orders
    //   return this.props.user.userProfile && this.props.user.userProfile.customer.access_orders_open;
    // }
  }

  getInStoreDescription(order, m) {

    console.log(m);

    if(m === 11) {
      return "14K Tacori Pendant";
    }

    if(order.description) {
      return order.description;
    } else {
      return ("In-Store Order (" + getLocationNameById(order.trans_loc) + ")");
    }
  }

  getStorePhone(order) {
    let store = getStoreByNumber(order.trans_loc);
    if(!store) {
      return null;
    }
    return store.phone;
  }

  getStoreEmail(order) {
    let store = getStoreByNumber(order.trans_loc);

    console.log(store);

    if(!store) {
      return null;
    }
    return store.email;
  }

	render() {

    console.log(this.props.user.orders);

		return <div className='AccountOrders'>
      <div className='sectionTitle'>
        <div>{this.props.showAll ? 'Order History' : 'Open Orders'}</div>
        {this.props.showAll === true ?
          <div className={this.state.rangeOpen ? 'ordersDropdown open' : 'ordersDropdown'} onClick={::this.toggleRangeOpen} style={{display: 'none'}}>
            <div className='ordersDropdownBody'>
              <div className='dropdownBodyWrapper'>
                <div className='dropdownItem' onClick={() => this.updateRange('Last 6 Months')}>Last 6 Months</div>
                <div className='dropdownItem' onClick={() => this.updateRange('Last Year')}>Last Year</div>
                <div className='dropdownItem' onClick={() => this.updateRange('Last 5 Years')}>Last 5 Years</div>
                <div className='dropdownItem' onClick={() => this.updateRange('Show All')}>Show All</div>
              </div>
            </div>
            <div className='ordersDropdownHead'>
              <div className='headDropdownValue'>
                {this.state.rangeValue}
              </div>
              <div className='dropdownIcon'>
                <i className={'fas fa-chevron-right'}></i>
              </div>
            </div>
          </div> :
          null
        }
      </div>
      <div className='ordersWrapper'>
        {false && this.externalOrderAccess() === false && this.props.showAll ?
          <div className='optWrapper' style={{display: 'none'}}>
            {this.props.openOrders ?
              <div>
                <div className='optText'>Click here to give permission to Diamonds Direct to sync your private, in-store order status to your online account.</div>
                <div className='optText'>Because your privacy and account security is our top priority, this process may take 3 to 5 business days.</div>
                <div className='optText'>For faster in-store order status, please contact the store in which your purchase was made.</div>
              </div> :
              <div>
                <div className='optText'>Click here to give permission to Diamonds Direct to sync your in-store order history to your online account.</div>
                <div className='optText'>Because your privacy and account security is our top priority, this process may take 3 to 5 business days.</div>
                <div className='optText'>For faster in-store order status, please contact the store in which your purchase was made.</div>
              </div>
            }
            <div className='optButton' onClick={::this.sendOptMessage}>
              <div>Opt In</div>
            </div>
          </div> :
          null
        }
        <div className='optWrapper'>
          <div className='optText'>Don’t see your pending order or your order history?  </div>
          <div className='optText'>Contact <a href='mailto:online@diamondsdirect.com'>online@diamondsdirect.com</a> or call <a href='tel:8008855050'>800.885.5050</a></div>
          <div className='optText'>We’re here to help!</div>
        </div>
        {false && !this.props.showAll ?
          <div className='openOrdersNotice'>
            For orders placed in store, please <span className='openNoticeLink' onClick={() => this.internalNav('locations')}>contact the store</span> in which you made your purchase.
          </div> :
          null
        }
        <div>
          {this.props.user.orders === null ?
            <div>
              <RhinoLoading />
            </div> :
            <div>
              {this.props.user.orders.length === 0 ?
                <div className={'nullOrder'}>No orders found.</div> :
                <div>
                  {this.props.user.orders.map((order, i) => {
                    return <div className={this.isOrderOpen(order) ? 'orderItem open' : 'orderItem'} key={i}>
                      <div className='orderHead'>
                        <div className='ohDate'>{this.getShortDate(order.created_at)}</div>
                        <div className='ohCount'>{this.getOrderCount(order)}</div>
                        <div className='ohNotes'>{this.getOrderStatus(order)}</div>
                        <div className='ohPriceWrapper'>
                          <div className='ohPriceSign'>$</div>
                          <div className='ohPriceDollars'>{this.getDollars(order.total)}.</div>
                          <div className='ohPriceCents'>{this.getCents(order.total)}</div>
                        </div>
                        <div className='ohIconWrapper' onClick={() => this.toggleOrderOpen(order)}>
                          {this.isOrderOpen(order) ? 
                            <div>&mdash;</div> :
                            <div>+</div>
                          }
                        </div>
                      </div>
                      <div className='orderBody'>
                        <div className='orderBodyWrapper'>
                          {order.items.map((product, j) => {
                            return <div className='productWrapper' key={j}>
                              <div className='prodImageWrapper'>
                                <img src={this.getItemImageUrl(product.image)} />
                              </div>
                              <div className='prodNameWrapper'>
                                <div className={'prodNamePrimary EllipsisElement'}>{product.name.replace(/Ã©/g, 'é')}</div>
                                <div className={'prodNameSku EllipsisElement'}><strong>SKU</strong>: {product.sku}</div>
                                <div className={'prodDescription'} dangerouslySetInnerHTML={{__html: this.getItemDescription(product)}} />
                              </div>
                              <div className='prodNotesWrapper'></div>
                              <div className='prodPriceWrapper'>${this.getDollars(product.price)}.{this.getCents(product.price)}</div>
                            </div>;
                          })}
                        </div>
                      </div>
                    </div>
                  })}
                  <div className='ordersDisclaimer' style={{display: 'none'}}>Dollar amount reflects price at date of original of purchase. <span className='disclaimerLink' onClick={() => this.internalNav('appointments')}>Connect with an expert</span> to place a duplicate order or to request up to date product and pricing information.</div>
                </div>
              }                
            </div>
          }

          {false && this.props.showAll ?
            <div>
              {this.props.user.externalOrders === null ?
                <div className='noExternal'></div> :
                <div className='haveExternal'>

                  {this.props.user.externalOrders ?
                    <div>
                      {this.props.user.externalOrders.map((order, m) => {

                        if(order.transaction_type != 'SLC') {
                          return null;
                        }

                        return <div className={this.isOrderOpen(order) ? 'orderItem open' : 'orderItem'} key={m}>
                          <div className='orderHead'>
                            <div className='ohDate'>{this.getShortDate(order.transaction_date)}</div>
                            <div className='ohCount'>{this.getOrderCount(order)}</div>
                            <div className='ohNotes' style={{display: 'none'}}></div>
                            <div className='ohPriceWrapper'>
                              <div className='ohPriceSign'>$</div>
                              <div className='ohPriceDollars'>{this.getDollars(order.item_sale_price)}.</div>
                              <div className='ohPriceCents'>{this.getCents(order.item_sale_price)}</div>
                            </div>
                            <div className='ohIconWrapper' onClick={() => this.toggleOrderOpen(order)}>
                              {this.isOrderOpen(order) ? 
                                <div>&mdash;</div> :
                                <div>+</div>
                              }
                            </div>
                          </div>
                          <div className='orderBody'>
                            <div className='orderBodyWrapper'>
                              {order.items.map((product, n) => {
                                return <div className='productWrapper' key={n}>
                                  <div className='prodImageWrapper'>
                                    <img src='https://ddw2.diamondsdirect.com/img/account/instore.jpg' />
                                  </div>
                                  <div className='prodNameWrapper'>
                                    <div className={'prodNamePrimary EllipsisElement'}>{this.getInStoreDescription(order, m)}</div>
                                    <div className={'prodNameSku EllipsisElement'}>SKU: {product.item_number}</div>
                                  </div>
                                  <div className={'prodNotesWrapper inStoreNotes'}>
                                    <div className='iconsLabel'>Need more help?</div>
                                    <a className='emailIcon' href={'mailto:' + this.getStoreEmail(order)}>
                                      <i className={"far fa-envelope"}></i>
                                    </a>
                                    <a className='phoneIcon' href={'tel:' + this.getStorePhone(order)}>
                                      <i className="fas fa-phone"></i>
                                    </a>
                                  </div>
                                </div>;
                              })}
                            </div>
                          </div>
                        </div>
                      })}
                      <div className='inStoreDisclaimer'>Dollar amount reflects price at date of original of purchase. <span className='disclaimerLink' onClick={() => this.internalNav('appointments')}>Connect with an expert</span> to place a duplicate order or to request up to date product and pricing information.</div>
                    </div> :
                    null
                  }

                </div>
              }
            </div> :
            null
          }

        </div>
      </div>
		</div>;
	}
}
export default AccountOrders;

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

export const AccountOrdersContainer = connect(
  mapStateToProps,
  allActionCreators
)(AccountOrders);


// WEBPACK FOOTER //
// ./src/components/views/account/blocks/AccountOrders.jsx